module.exports = __webpack_public_path__ + "img/right-blue-arrow.8421ded5.svg";